import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicReviewCardComponent } from './dynamic-card-review/dynamic-card-review.component';
import { StandardCardReviewRendererComponent } from './standard-card-review-renderer/standard-card-review-renderer.component';
import { CardResolverModule } from '../resolver/card-resolver.module';
import { CardReviewHeaderComponent } from './card-review-header/card-review-header.component';
import { CardReviewFieldsComponent } from './card-review-fields/card-review-fields.component';
import { CoreReviewPageRendererBaseComponent } from '../../page/shared/core-review-page-renderer-base.component';
import { CoreReviewCardRendererBaseComponent } from '../shared/core-review-card-rendere-base.component';

const components = [
  DynamicReviewCardComponent,
  StandardCardReviewRendererComponent,
  CardReviewHeaderComponent,
  CardReviewFieldsComponent,
  CoreReviewPageRendererBaseComponent,
  CoreReviewCardRendererBaseComponent
];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, CardResolverModule]
})
export class CardReviewModule {}
